import { render, staticRenderFns } from "./ArchiveNormal.vue?vue&type=template&id=32689af1&scoped=true&lang=pug&"
import script from "./ArchiveNormal.vue?vue&type=script&lang=js&"
export * from "./ArchiveNormal.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveNormal.scss?vue&type=style&index=0&id=32689af1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32689af1",
  null
  
)

export default component.exports